// extracted by mini-css-extract-plugin
export default {"container":"Table_container__pUIGA","fixed":"Table_fixed__9iMPv","pinIcon":"Table_pinIcon__onBse","custom":"Table_custom__AKuz1","minimal":"Table_minimal__+PdGP"};